<template>
  <div class="collectiongroupeditor">
    <div class="collectiongroupeditor__header">
      <div class="collectiongroupeditor__header__left">
        <h1 class="medium-title">Collection Group Editor</h1>
      </div>
      <div class="collectiongroupeditor__header__right">
      </div>
    </div>
    <div class="collectiongroupeditor__content">
      <div class="collectiongroupeditor__content__left">
        <div class="collectiongroupeditor__content__left__about">
          <div class="collectiongroupeditor__content__left__about__title">
            <h3>Group information</h3>
          </div>
          <div class="collectiongroupeditor__content__left__about__form">
            <div class="collectiongroupeditor__content__left__about__form__inline">
              <adx-input :label="`Group Name`" :value.sync="item.title" :error.sync="inputNameError" :validation="['NotEmpty']" :validationMethod="'onChange'"/>
              <adx-input :label="`Remark`" :value.sync="item.remarks" />
            </div>
          </div>
        </div>
        <div class="collectiongroupeditor__content__left__about">
          <div class="collectiongroupeditor__content__left__about__title">
            <h3>Description</h3>
          </div>
          <div class="collectiongroupeditor__content__left__about__form">
            <adx-textarea :label="`Collection Description`" :value.sync="item.description"
            :error.sync="inputDescError" :validation="['NotEmpty']"/>
          </div>
        </div>
      </div>
      <div class="collectiongroupeditor__content__right">
        <div class="collectiongroupeditor__content__right__totallisting">
          <div class="collectiongroupeditor__content__right__totallisting__header">
            <div class="title">
              <h3>Total Collection</h3>
            </div>
            <div class="count">
              {{selectedItems ? selectedItems.length : 0}} Items
            </div>
          </div>
          <div class="collectiongroupeditor__content__right__totallisting__view">
            <button class="btn-small secondary" @click.stop="toggleViewAll">Edit</button>
            <button class="btn-small primary" @click.stop="toggleView">Add</button>
          </div>
        </div>
        <div class="collectiongroupeditor__content__right__visibility">
          <div class="collectiongroupeditor__content__right__visibility__header">
            <h3>Group Visibility</h3>
          </div>
          <div class="collectiongroupeditor__content__right__visibility__dropdown">
            <adx-selectdropdown :value.sync="item.visibility" :label="`Visibility`" :options="dropdown" />
          </div>
        </div>
        <div class="collectiongroupeditor__content__right__visibility">
          <div class="collectiongroupeditor__content__right__visibility__header">
            <h3>Group Layout</h3>
          </div>
          <div class="collectiongroupeditor__content__right__visibility__dropdown">
            <adx-selectdropdown :value.sync="item.layout" :label="`Layout`" :options="layoutDropdown" />
          </div>
        </div>
        <div class="collectiongroupeditor__content__right__action">
          <button class="btn-regular primary" @click.stop="publish" :disabled="isLoadingPublish || (notValidName || notValidDesc)">
            Publish
            <adx-loading-secondary v-if="isLoadingPublish" slot="loading" />
          </button>
        </div>
      </div>
    </div>
    <modal v-if="isOpen" @modal-close="toggleView" :type="`large`">
      <div slot="content" class="content">
        <div class="content__header">
          <h3 class="title">{{item.title}}</h3>
          <p class="total">Total Collection {{selectedItems ? selectedItems.length : 0}} Items</p>
        </div>
        <div class="content__listing">
          <adx-list-item @reloadData="loadDataCollection" :items='unselectedItems' :type="`unselected`" />
        </div>
      </div>
    </modal>
    <modal v-if="isOpenViewAll" @modal-close="toggleViewAll" :type="`large`">
      <div slot="content" class="content">
        <div class="content__header">
          <h3 class="small-title title">{{item.title}}</h3>
          <p class="total">Total Collection {{selectedItems ? selectedItems.length : 0}} Items</p>
        </div>
        <div class="content__listing">
          <adx-loading v-if="isLoadingUpdate" />
          <adx-list-item v-else @orderChanged="updateData" @reloadData="loadDataCollection" :items='selectedItems' :type="`selected`" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import FormAbstraction from '@/components/Form'
import Modal from '@/components/Modal'
import ListItem from '@/views/Collection/CollectionGroupEditor/ListItem'
import Input from '@/components/Form/Input'
import Textarea from '@/components/Form/TextArea'
import LoadingSecondary from '@/components/Loading/Secondary'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import types from '@/lib/types'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types


export default {
  name: 'adx-collection-editor',
  components: {
    'adx-form-abstraction': FormAbstraction,
    'adx-selectdropdown': SelectDropdown,
    'modal': Modal,
    'adx-list-item': ListItem,
    'adx-input': Input,
    'adx-textarea': Textarea,
    'adx-loading-secondary': LoadingSecondary,
    'adx-loading': Loading,
  },
  props: {

  },
  data() {
    return {
      isOpen: false,
      isOpenViewAll: false,
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        name: ``,
        description: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: `button-group inline`
        }
      },
      schema: [
        {
          type: 'inline',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Group name',
              model: 'groupname',
              validation: ['NotEmpty', 'MinLength:6']
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Remark',
              model: 'remark',
              validation: ['NotEmpty', 'MinLength:6']
            },
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'textarea',
              inputType: 'text',
              label: 'Collection Group Description',
              model: 'description',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        }
      ],
      dropdown: [
        {
          label: 'Public',
          value: 'Public'
        },
        {
          label: 'Private',
          value: 'Private'
        }
      ],
      layoutDropdown: [
        {
          label: 'Featured Collection',
          value: 'FE'
        },
        {
          label: 'Regular Collection',
          value: 'RE'
        }
      ],
      item: {
        title: '',
        description: '',
        visibility: '',
        remarks: '',
        layout: ''
      },
      unselectedItems: [],
      selectedItems: [],
      isLoadingPublish: false,
      inputNameError: '',
      inputDescError: '',
      notValidName: true,
      notValidDesc: true,
      isLoadingUpdate: false
    }
  },
  computed: {

  },
  watch: {
    inputNameError() {
      this.notValidName = this.inputNameError
    },
    inputDescError() {
      this.notValidDesc = this.inputDescError
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
    this.loadDataCollection()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    updateData() {
      this.$nextTick(function () {
        this.loadDataCollection()
      })
    },
    toggleView() {
      (async () => {
        this.isLoadingPublish = true

        const id = this.$route.params.id
        const data = {
          id: id,
          title: this.item.title,
          description: this.item.description,
          remarks: this.item.remarks,
          visibility: this.item.visibility == 'Public' ? true : false,
          layout: this.item.layout
        }

        const response = await api.put(apiV2.collectionGroupDetail(id), data, { needToken: true })

        this.isLoadingPublish = false

        this.$router.push({ name: 'addmorecollectiongroup', params: { id: id } })
      })();
    },
    toggleViewAll() {
      this.isOpenViewAll = !this.isOpenViewAll
    },
    loadData() {
      (async () => {
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionGroupDetail(id), { needToken: true })
        if (data.title) {
          this.inputNameError = false
        }
        if (data.description) {
          this.inputDescError = false
        }
        this.item.title = data.title
        this.item.description = data.description
        this.item.visibility = data.status
        this.item.remarks = data.remarks
        this.item.layout = data.layout

      })();
    },
    loadDataCollection() {
      (async () => {
        this.isLoadingUpdate = true
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionGroupUnselected(id), { needToken: true })

        this.unselectedItems = data.results

      })();
      (async () => {
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionGroupSelected(id), { needToken: true })

        this.selectedItems = data
        this.isLoadingUpdate = false
      })();
    },
    publish() {
      (async () => {
        this.isLoadingPublish = true

        const id = this.$route.params.id
        const data = {
          id: id,
          title: this.item.title,
          description: this.item.description,
          remarks: this.item.remarks,
          visibility: this.item.visibility == 'Public' ? true : false,
          layout: this.item.layout
        }

        const response = await api.put(apiV2.collectionGroupDetail(id), data, { needToken: true })

        this.isLoadingPublish = false

        this.$router.push({name: 'collectiongroup'})
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>